/* Component Dependencies */
var fitnessAndRecreationTemplate = require('templates/fitnessAndRecreation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'fitnessAndRecreation',
  template: {
    'fitnessAndRecreation': fitnessAndRecreationTemplate
  }
});
